import { NotificationConfigurationsData } from "../types/configurations.type";

export class NotificationsConfigurationsTransformer {

  static strategyTransformer() {
    return (notificationsConfigurations: NotificationConfigurationsData[]) => {
      return notificationsConfigurations.reduce((prev, current) => {
        return {
          ...prev,
          [current.notification_klass]: {
            ...current,
          },
        }
      }, {});
    }
  }

}
